import isMobilePhone from 'validator/lib/isMobilePhone';

import removeNotNumberFromString from '../inputFormat/removeNotNumberFromString';

export const ERROR_MESSAGE_SHOULD_HAVE_PHONE_NUMBER = '휴대폰 번호를 입력해 주세요.';
export const ERROR_MESSAGE_SHOULD_START_ZERO_ONE = "'01'로 시작하는 휴대폰 번호를 입력해주세요.";
export const ERROR_MESSAGE_INVALID_PHONE_NUMBER = '유효하지 않은 번호입니다.';

function validatePhoneNumber(value: string) {
  let message = '';
  let success = false;

  if (!value) {
    message = ERROR_MESSAGE_SHOULD_HAVE_PHONE_NUMBER;
  } else if (!value.startsWith('01')) {
    message = ERROR_MESSAGE_SHOULD_START_ZERO_ONE;
  } else if (!isMobilePhone(value, 'ko-KR')) {
    message = ERROR_MESSAGE_INVALID_PHONE_NUMBER;
  } else if (value.startsWith('010') && removeNotNumberFromString(value).length !== 11) {
    /**
     * 010으로 시작하는 폰번호 가운데 자리는 4자리
     * @see https://namu.wiki/w/국번#s-5.2
     */
    message = ERROR_MESSAGE_INVALID_PHONE_NUMBER;
  } else {
    message = '';
    success = true;
  }

  return { success, message };
}

export default validatePhoneNumber;
